<template>
    <v-btn
    :class="[baseClass, { 'PrimaryButton': isPrimary ,'disabled-button': disabled}]"
    elevation="0"
    :disabled="disabled"
    @click="handleClick"
    :style="{ width: buttonWidth }"
    >
        {{ buttonText }}
    </v-btn>
</template>

<script>
export default {
	name: 'TextButtonBlock',
    props: {

        buttonText: {
        type: String,
        default: 'Save'
        },
        isPrimary: {
        type: Boolean,
        default: false
        },
        buttonClass: {
        type: String,
        default: 'TextButton'
        },
        width: {
        type: String,
        default: '50%'
        },
        disabled: { 
        type: Boolean,
        default: false
        },
    },
    computed: {
    baseClass() {
        return this.isPrimary ? 'PrimaryButton' : 'TextButton';
    },
    buttonWidth() {
      return this.width;
    }
  },
    methods: {
        handleClick() {
            this.$emit('click');
        }
    }
};
</script>

<style scoped>
.TextButton { background: #fff !important;border: 1px solid #bbb; }
.PrimaryButton {background: #007bff !important;color: #fff;}
.BlackButton { background: #000 !important;color: #fff; }
.disabled-button {background: #eee !important;pointer-events: none;}
</style>